var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCheck = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 80 80",
  ref: svgRef
}, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "3F20FC3C-8374-4C70-B3C1-399DB66A5259@3x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Your-new-password-has-been-set",
  transform: "translate(-680.000000, -325.000000)",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(680.000000, 325.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 40,
  cy: 40,
  r: 39
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Rectangle-5",
  transform: "translate(41.561553, 34.561553) rotate(-45.000000) translate(-41.561553, -34.561553) ",
  points: "59.061553 43.311553 24.061553 43.311553 24.061553 25.811553"
}))))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.f7dac01e.svg";
export { ForwardRef as ReactComponent };